import { render, staticRenderFns } from "./ButtonVue.vue?vue&type=template&id=a6d1a166&scoped=true"
import script from "./ButtonVue.vue?vue&type=script&lang=js"
export * from "./ButtonVue.vue?vue&type=script&lang=js"
import style0 from "./ButtonVue.vue?vue&type=style&index=0&id=a6d1a166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d1a166",
  null
  
)

export default component.exports